module.exports = new __parcel__URL__("Palikkatakomo.f7a50058.webp").toString();